<template>
  <header class="navbar">
    <a href="/" class="navbar-left">
      <img
        src="@/assets/Objekt.png"
        alt="Autoheaven Logo"
        class="navbar-logo"
      />
      <p class="navbar-subtitle">
        <router-link to="/detailing" class="nav-link">Detailing</router-link>
        |
        <router-link to="/tunning" class="nav-link">Tunning</router-link>
        <!--  <router-link to="/polish" class="nav-link">Polish</router-link>
        |
        
        <router-link to="/colantare" class="nav-link">Wrapping</router-link>
        
        <router-link to="/folii-solare" class="nav-link">Tinting</router-link> -->
        |
        <router-link to="/trape-panoramice" class="nav-link"
          >Trape Panoramice</router-link
        >
        |
        <router-link to="/mecanica" class="nav-link">Mecanica</router-link>
      </p>
    </a>

    <button class="burger" @click="toggleMenu">☰</button>

    <!-- MENIU DESKTOP -->
    <nav class="navbar-right">
      <router-link to="/" class="nav-link" exact>HOME</router-link>

      <div class="dropdown">
        <button class="dropbtn">SERVICII</button>
        <div class="dropdown-content">
          <router-link
            to="/detailing"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Detailing</router-link
          >
          <router-link to="/polish" class="dropdown-link">Polish</router-link>
          <!--<router-link
            to="/folii-solare"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Folii Solare</router-link
          >
          <router-link
            to="/colantare"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Colantare</router-link
          >
          <router-link to="/ppf" class="dropdown-link">PPF</router-link> -->
          <router-link
            to="/lumini-ambientale"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Lumini Ambientale</router-link
          >
          <router-link
            to="/trape-panoramice"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Trape / Panoramice</router-link
          >
          <router-link
            to="/tunning"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Tunning</router-link
          >

          <router-link
            to="/mecanica"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Mecanica</router-link
          >

          <!--<router-link
            to="/retapitari"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Retapitări</router-link
          >
           <router-link
            to="/insonorizari"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Insonorizări</router-link
          >
          <router-link
            to="/polish-sticla"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Polish Sticlă</router-link
          >-->
          <router-link
            to="/vopsire-piele"
            class="dropdown-link"
            @click="toggleMenu(false)"
            >Vopsire Piele</router-link
          >
        </div>
      </div>

      <router-link to="/galerie" class="nav-link">GALERIE</router-link>
      <router-link to="/despre-noi" class="nav-link">DESPRE NOI</router-link>
      <router-link to="/contact" class="nav-link">CONTACT</router-link>
      <a
        href="https://www.auto-heaven.eu/"
        target="_blank"
        rel="noopener"
        class="shop-btn"
        >SPRE MAGAZIN</a
      >

      <a
        class="programare-btn"
        href="#"
        @click.prevent="showWhatsappForm = true"
      >
        Programează o vizită
      </a>
    </nav>
    <!-- FORMULAR WHATSAPP -->
    <transition name="fade">
      <div v-if="showWhatsappForm" class="whatsapp-form-overlay">
        <div class="whatsapp-form">
          <h3>Programează o vizită prin WhatsApp</h3>
          <label>
            Nume:
            <input
              v-model="form.name"
              type="text"
              placeholder="Ex: Andrei Pop"
            />
          </label>
          <label>
            Telefon:
            <input
              v-model="form.phone"
              type="text"
              placeholder="07xx xxx xxx"
            />
          </label>
          <label>
            Serviciu dorit:
            <input
              v-model="form.service"
              type="text"
              placeholder="Ex: Detailing interior"
            />
          </label>
          <label>
            Alte detalii:
            <textarea
              v-model="form.details"
              placeholder="Ex: data preferată, mașina, observații..."
            ></textarea>
          </label>

          <div class="form-buttons">
            <button @click="sendWhatsappMessage">Trimite pe WhatsApp</button>
            <button class="cancel" @click="showWhatsappForm = false">
              Anulează
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- MENIU MOBIL SLIDE DIN DREAPTA -->
    <transition name="slide">
      <!-- ✅ overlay: click pe fundal închide meniul -->
      <div v-if="menuOpen" class="mobile-overlay" @click="toggleMenu(false)">
        <!-- ✅ stop: click în drawer NU închide meniul -->
        <nav class="mobile-drawer" @click.stop>
          <router-link to="/" class="nav-link" @click="toggleMenu(false)"
            >HOME</router-link
          >

          <div class="dropdown">
            <button class="dropbtn">SERVICII</button>
            <div class="dropdown-content">
              <router-link
                to="/detailing"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Detailing</router-link
              >
              <router-link
                to="/polish"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Polish</router-link
              >
              <!-- <router-link
                to="/folii-solare"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Folii Solare</router-link
              >
              <router-link
                to="/colantare"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Colantare</router-link
              >
              <router-link
                to="/ppf"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >PPF</router-link
              >-->
              <router-link to="/lumini-ambientale" class="dropdown-link"
                >Lumini Ambientale</router-link
              >
              <router-link
                to="/trape-panoramice"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Trape / Panoramice</router-link
              >
              <!-- <router-link
                to="/retapitari"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Retapitări</router-link
              > -->
              <router-link
                to="/insonorizari"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Insonorizări</router-link
              >
              <router-link
                to="/tunning"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Tunning</router-link
              >

              <router-link
                to="/mecanica"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Mecanica</router-link
              >
              <!--  <router-link
                to="/polish-sticla"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Polish Sticlă</router-link
              > -->
              <router-link
                to="/vopsire-piele"
                class="dropdown-link"
                @click="toggleMenu(false)"
                >Vopsire Piele</router-link
              >
            </div>
          </div>

          <router-link to="/galerie" class="nav-link" @click="toggleMenu(false)"
            >GALERIE</router-link
          >
          <router-link
            to="/despre-noi"
            class="nav-link"
            @click="toggleMenu(false)"
            >DESPRE NOI</router-link
          >
          <router-link to="/contact" class="nav-link" @click="toggleMenu(false)"
            >CONTACT</router-link
          >

          <a
            href="https://www.auto-heaven.eu/"
            class="shop-btn mobile"
            target="_blank"
            rel="noopener"
            @click="toggleMenu(false)"
          >
            Spre magazin
          </a>

          <button
            class="programare-btn"
            @click="
              $emit('open-form');
              toggleMenu(false);
            "
          >
            Programează o vizită
          </button>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      menuOpen: false,
      showWhatsappForm: false,
      whatsappNumber: "40773383914", // numărul firmei, fără + sau spații
      form: {
        name: "",
        phone: "",
        service: "",
        details: "",
      },
    };
  },
  methods: {
    toggleMenu(forceClose = null) {
      if (forceClose === false) this.menuOpen = false;
      else this.menuOpen = !this.menuOpen;
    },

    sendWhatsappMessage() {
      const { name, phone, service, details } = this.form;

      // ✔️ Evită tăierea numărului de telefon în WhatsApp
      const fixedPhone =
        phone.startsWith("0") && phone.length > 1
          ? `0\u200B${phone.slice(1)}`
          : phone;

      // ✔️ Mesaj cu formatare frumoasă (emoji + bold)
      const message = `
Salut!
Aș dori să programez o vizită la *AutoHeaven*.

*Detalii client:*
• Nume: ${name || "-"}
• Număr de telefon: ${fixedPhone || "-"}
• Serviciul dorit: ${service || "-"}
• Alte detalii: ${details || "-"}

Vă rog să mă contactați pentru confirmare.
`;

      const url = `https://wa.me/${
        this.whatsappNumber
      }?text=${encodeURIComponent(message)}`;

      window.open(url, "_blank"); // deschide WhatsApp Web / aplicația mobilă
      this.showWhatsappForm = false; // închide formularul
    },
  },
};
</script>

<style scoped>
.navbar {
  background-color: #000;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.navbar-logo {
  max-height: 80px;
  max-width: 230px;
  object-fit: contain;
  display: block;
  margin-bottom: 5px;
}

.navbar-subtitle {
  font-size: 14px;
  color: #ccc;
  text-align: center;
  margin: 0;
  white-space: nowrap;
}

.burger {
  display: none;
  font-size: 28px;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

.navbar-right {
  display: flex;
  gap: 15px;
  align-items: center;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.2s;
}

.nav-link:hover {
  color: goldenrod;
}

/* === DROPDOWN === */
.dropdown {
  position: relative;
}
.dropbtn {
  background: none;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #111;
  min-width: 180px;
  z-index: 1000;
  top: 100%;
  left: 0;
  border-radius: 5px;
  padding: 0.5rem 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}
.dropdown:hover .dropdown-content {
  display: block;
}
.dropdown-link {
  color: white;
  padding: 0.5rem 1rem;
  display: block;
  text-decoration: none;
}
.dropdown-link:hover {
  color: goldenrod;
}

.programare-btn {
  background-color: white;
  padding: 8px 15px;
  border-radius: 3px;
  color: black;
  text-decoration: none;
  font-weight: bold;
}

.programare-btn:hover {
  color: goldenrod;
}

/* ✅ overlay pentru click “lângă meniu” */
.mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1999;
}

/* === SLIDE MENIU MOBIL === */
.mobile-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background-color: #111;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 1rem;
  z-index: 2000;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.4);
}

.mobile-drawer .nav-link,
.mobile-drawer .dropbtn,
.mobile-drawer .dropdown-link {
  color: white;
  font-size: 1rem;
  font-weight: bold;
  text-decoration: none;
  padding: 10px;
  text-align: left;
}

.mobile-drawer .dropdown-content {
  position: static;
  box-shadow: none;
  padding: 0;
}

.mobile-drawer .dropdown-link:hover,
.mobile-drawer .nav-link:hover {
  color: goldenrod;
}

.mobile-drawer .programare-btn {
  background-color: white;
  color: black;
  font-weight: bold;
  border-radius: 6px;
  padding: 10px;
  margin-top: auto;
}

/* ✅ Animatie: fade overlay + slide drawer */
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.25s ease;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}

.slide-enter-active .mobile-drawer,
.slide-leave-active .mobile-drawer {
  transition: transform 0.3s ease;
}
.slide-enter-from .mobile-drawer,
.slide-leave-to .mobile-drawer {
  transform: translateX(100%);
}

.shop-btn {
  background: transparent;
  border: 2px solid goldenrod;
  padding: 7px 12px;
  border-radius: 6px;
  color: goldenrod;
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1;
  transition: 0.2s;
}

.shop-btn:hover {
  background: goldenrod;
  color: #000;
}

/* pe mobil să arate ca un buton full */
.shop-btn.mobile {
  text-align: center;
  padding: 12px;
  border-radius: 8px;
}

/* Responsive rules */
@media (max-width: 768px) {
  .burger {
    display: block;
  }
  .navbar-right {
    display: none !important;
  }
}
/* === FORMULAR WHATSAPP === */
.whatsapp-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

.whatsapp-form {
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.2);
}

.whatsapp-form h3 {
  color: #facc15;
  margin-bottom: 1rem;
  text-align: center;
}

.whatsapp-form label {
  display: block;
  margin-bottom: 0.8rem;
}

.whatsapp-form input,
.whatsapp-form textarea {
  width: 100%;
  padding: 0.6rem;
  border-radius: 6px;
  border: 1px solid #333;
  margin-top: 0.2rem;
  background: #222;
  color: #fff;
  font-size: 0.95rem;
}

.whatsapp-form textarea {
  height: 80px;
  resize: none;
}

.form-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.form-buttons button {
  flex: 1;
  margin: 0 5px;
  padding: 0.6rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.form-buttons button:hover {
  opacity: 0.9;
}

.form-buttons button:first-child {
  background: #25d366;
  color: #fff;
}

.form-buttons .cancel {
  background: #444;
  color: #ccc;
}

/* fade-in animatie */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
